var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "delete"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.28614 2.17188H15.2861C15.7011 2.17188 16.0361 1.83688 16.0361 1.42188C16.0361 1.00688 15.7011 0.671875 15.2861 0.671875H6.28614C5.87113 0.671875 5.53613 1.00688 5.53613 1.42188C5.53613 1.83688 5.87113 2.17188 6.28614 2.17188ZM1.03614 3.67188H20.5361C20.9511 3.67188 21.2861 4.00688 21.2861 4.42188C21.2861 4.83688 20.9511 5.17188 20.5361 5.17188H1.03614C0.621134 5.17188 0.286133 4.83688 0.286133 4.42188C0.286133 4.00688 0.621134 3.67188 1.03614 3.67188ZM18.0125 21.4559L18.2835 8.22781H19.7835L19.5125 21.4869C19.4765 23.2569 18.0305 24.6719 16.2605 24.6719H5.42345C3.65345 24.6719 2.20844 23.2569 2.17244 21.4869L1.90044 8.22781H3.40045L3.67145 21.4559C3.69145 22.4019 4.47745 23.1719 5.42345 23.1719H16.2605C17.2075 23.1719 17.9935 22.4019 18.0125 21.4559Z",
  fill: "#474747"
})));

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f5bce033.svg";
export { ForwardRef as ReactComponent };